import { render, staticRenderFns } from "./RecommendReplyList.vue?vue&type=template&id=31218c34&scoped=true&"
import script from "./RecommendReplyList.vue?vue&type=script&lang=js&"
export * from "./RecommendReplyList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendReplyList.vue?vue&type=style&index=0&id=31218c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31218c34",
  null
  
)

export default component.exports